// extracted by mini-css-extract-plugin
export default {"footer__links":"footer_footer__links__AMDlP","footer__socials":"footer_footer__socials__Jk9KD","footer":"footer_footer__R1A6a"};